import { createSelector } from 'reselect'

/**
 * Select the tip state slice
 * @param {object} state - Redux state
 * @returns {object} Tip state
 */
export const selectTip = (state) => state.tip

/**
 * Select tip file uploads
 * @param {object} state - Redux state
 * @returns {Array} File uploads
 */
export const selectFileUploads = createSelector(
  selectTip,
  (tip) => tip.fileUploads
)

/**
 * Select whether a file is currently uploading
 * @param {object} state - Redux state
 * @returns {boolean} Upload in progress
 */
export const selectIsUploadingFile = createSelector(
  selectTip,
  (tip) => tip.isUploadingFile
)

/**
 * Select the current file upload
 * @param {object} state - Redux state
 * @returns {object|null} Current file upload
 */
export const selectCurrentFileUpload = createSelector(
  selectTip,
  (tip) => tip.currentFileUpload
)

/**
 * Select the upload progress percentage
 * @param {object} state - Redux state
 * @returns {number} Upload progress
 */
export const selectUploadProgress = createSelector(
  selectTip,
  (tip) => tip.uploadProgress
)

/**
 * Select whether the tip success modal is visible
 * @param {object} state - Redux state
 * @returns {boolean} Success modal visibility
 */
export const selectShowTipSuccessModal = createSelector(
  selectTip,
  (tip) => tip.showTipSuccessModal
)

/**
 * Select the tip confirmation text
 * @param {object} state - Redux state
 * @returns {string} Confirmation text
 */
export const selectTipConfirmationText = createSelector(
  selectTip,
  (tip) => tip.tipConfirmationText
)

/**
 * Select whether tip is awaiting location
 * @param {object} state - Redux state
 * @returns {boolean} Awaiting location status
 */
export const selectTipIsAwaitingLocation = createSelector(
  selectTip,
  (tip) => tip.isAwaitingLocation
)

/**
 * Select whether the files modal is visible
 * @param {object} state - Redux state
 * @returns {boolean} Files modal visibility
 */
export const selectShowFilesModal = createSelector(
  selectTip,
  (tip) => tip.showFilesModal
)

/**
 * Select the expanded file in files modal
 * @param {object} state - Redux state
 * @returns {object|null} Expanded file
 */
export const selectExpandedFile = createSelector(
  selectTip,
  (tip) => tip.expandedFile
)

/**
 * Select the card media files
 * @param {object} state - Redux state
 * @returns {Array} Card media files
 */
export const selectCardMediaFiles = createSelector(
  selectTip,
  (tip) => tip.cardMediaFiles
)
